import { render, staticRenderFns } from "./MyOrderDetails.vue?vue&type=template&id=bc29a27e&scoped=true"
import script from "./MyOrderDetails.vue?vue&type=script&lang=js"
export * from "./MyOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./MyOrderDetails.vue?vue&type=style&index=0&id=bc29a27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc29a27e",
  null
  
)

export default component.exports